import { Pipe, PipeTransform } from '@angular/core';
import { ProjectLanguage } from '../../firestore-models/project-language';

@Pipe({
  name: 'multiQitem',
  standalone: false,
})
export class MultiQitemPipe implements PipeTransform {

  transform(values: Array<{lang_code: string, item: string}>, languages: Array<ProjectLanguage>,currentLang: string = 'ja'): string {
    let item: string = '';
    if (!!values) {
      const language = languages.find(lang => lang.lang_code === currentLang);//#216 日本語固定になっているので、admin_lang_modeに従って出し分ける
      // const language = languages[0];
      if (language) {
        for (const value of values) {
          if (language.lang_code === value.lang_code) {
            item = value.item;
            break;
          }
        }
      }
    }
    return item;
  }

}
